module.exports = __webpack_public_path__ + "static/media/firefox-android.f8815d9b.png";